<template>

    <div>
        <div class="card" style='margin:auto;max-width:400px;'>


          <div class="card-content">

              <center>
                  <b-icon icon="check" size='is-large' type='is-success' />
                  <h2 class='title is-4'>Checkout successful!</h2>
                  <hr/>

                  <figure class="image is-4by3">
                    <img :src="project.image[0].sizes.card">
                  </figure>
                  <h3 class='title is-5'>{{project.name}}</h3>
                  <p>{{project.description}}</p>

                  <hr/>

                  <b-button tag="router-link" class='button is-fullwidth'
                    :to="'/project/' + project.id">
                    Return to project page
                  </b-button>

              </center>

          </div>
        </div>
    </div>

</template>

<style scoped>
  h3 { margin-top: 10px; }
  p { text-align: justify; }
</style>

<script>
export default {
  name: 'CheckoutSuccess',
  data () {
    return {
        project: {},
        error: ''
    }
  },
  mounted() {
      var that = this;
      this.$http.get(this.$hostname + '/project/' + this.$route.params.projectId).then(function(response) {
          if(response.status === 200) {
              that.project = response.body;
          }
      }, function(error) {
          this.error = 'Something went wrong with this transaction. Please try again';
      });
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/CheckoutSuccess.vue